import script from "./VisitClientStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitClientStatus.vue?vue&type=script&setup=true&lang=js"

import "./VisitClientStatus.vue?vue&type=style&index=0&id=fe8c24a6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe8c24a6"]])

export default __exports__